import {
  useMutation,
  UseMutationResult,
  useQuery,
  useQueryClient,
  UseQueryResult,
} from "@tanstack/react-query";
import { logException } from "@punchup/sentry";
import {
  fetchManagerSubscriptions,
  updateManagerSubscription,
  UpdateSubscriptionRequest,
  ManagerSubscriptionProduct,
} from "../../client/manager/subscriptions";

export function useManagerSubscriptions(
  comedianId: string
): UseQueryResult<ManagerSubscriptionProduct[], Error> {
  return useQuery({
    queryKey: ["managerSubscriptions", comedianId],
    queryFn: () => fetchManagerSubscriptions(comedianId),
    enabled: !!comedianId,
    staleTime: 60_000,
  });
}

export function useUpdateManagerSubscription(
  comedianId: string
): UseMutationResult<
  void,
  Error,
  { productId: string; payload: UpdateSubscriptionRequest }
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      productId,
      payload,
    }: {
      productId: string;
      payload: UpdateSubscriptionRequest;
    }) => updateManagerSubscription(productId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["managerSubscriptions", comedianId],
      });
    },
    onError: (err) => {
      logException(err, {
        data: "[useUpdateManagerSubscription] Failed to update subscription",
      });
    },
  });
}
